import * as React from "react"
import { Redirect, Route, RouteProps } from "react-router-dom"
import { useApplicationContext } from "../context/applicationContext"
import { LOGIN_LANDING } from "constants/paths"
import { RedirectProps } from "react-router"
import { LanguageDictionary, LANGUAGES } from "../constants/language"

type componentType = typeof React.Component | React.ReactElement | React.FC
interface PrivateRouteProps {
	component: componentType
	path?: string
	languages?: LanguageDictionary
}
const PrivateRoute: React.FC<
	PrivateRouteProps | (PrivateRouteProps & RedirectProps & RouteProps)
> = (props) => {
	const { component, languages, path, ...rest } = props
	const { isAuthenticated } = useApplicationContext()

	return (
		<Route
			{...rest}
			path={path}
			render={(props) => {
				if (isAuthenticated) {
					return (
						<RenderComponent
							languages={languages}
							component={component}
							{...props}
						/>
					)
				}
				return (
					<Redirect
						to={{
							pathname: LOGIN_LANDING,
							state: {
								from: props.location,
							},
						}}
					/>
				)
			}}
		/>
	)
}

const RenderComponent: React.FC<PrivateRouteProps> = (props): JSX.Element => {
	const { component: Component, languages = LANGUAGES } = props
	const { selectLanguage, setAllowedLocales } = useApplicationContext()

	React.useEffect(() => {
		setAllowedLocales(languages)

		const hasOnlyOneAllowedTranslation = Object.keys(languages).length === 1
		if (hasOnlyOneAllowedTranslation) {
			const translation = Object.values(languages)[0]
			selectLanguage(translation)
		}
	}, [])

	if (React.isValidElement(Component)) {
		return <React.Fragment>{Component}</React.Fragment>
	}

	return <Component {...props} />
}

export default PrivateRoute
